import React from "react";
import { Skeleton } from "../ui/Primitives";

/** Placeholder with the same rhythm as a real page, shown while a route loads. */
export function PageSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading">
      <Skeleton height={12} width={120} />
      <Skeleton height={28} width={280} style={{ marginTop: 12 }} />
      <Skeleton height={14} width={420} style={{ marginTop: 12, maxWidth: "80%" }} />
      <div className="grid grid--kpi" style={{ marginTop: 28 }}>
        {[0, 1, 2, 3].map((i) => (
          <div className="card" key={i} style={{ padding: 20 }}>
            <Skeleton height={12} width="55%" />
            <Skeleton height={26} width="75%" style={{ marginTop: 14 }} />
            <Skeleton height={10} width="45%" style={{ marginTop: 14 }} />
          </div>
        ))}
      </div>
      <div className="grid grid--main" style={{ marginTop: 16 }}>
        <div className="card" style={{ padding: 20 }}>
          <Skeleton height={14} width={200} />
          <Skeleton height={260} style={{ marginTop: 20 }} />
        </div>
        <div className="card" style={{ padding: 20 }}>
          <Skeleton height={14} width={160} />
          <Skeleton height={160} width={160} style={{ marginTop: 20, borderRadius: "50%" }} />
        </div>
      </div>
    </div>
  );
}
